import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const ViviFirEditorFir: AnaColumn[] = [


    {
      itemType: "group", caption: 'N° FIR da generare', class: '', colCount: "2", data: [
  
        {
          type: 'campoDesc', dataField: "blocco", colVisible: false, dataType: "", caption: "Blocco", hideOnEdit: false,
          width: '70'
        },
  
        {
          type: 'campoDesc', dataField: "progressivo", colVisible: true, dataType: "", caption: "N° progr del blocco", hideOnEdit: false,
          width: '45',
        },
  
        {
          type: 'campo', dataField: "numfir", colVisible: false, caption: "N° FIR da generare", hideOnEdit: false,
          editorType: 'dxNumberBox', colSpan: '2', width: 9.1 * aspect, maxLength: '4', maxSize: 9,
          validation: [
            { type: 'required', message: 'Inserire il n° di fir da generare' },
            {
              type: 'range', min: '1', max: '1000', message: 'Non puoi inserire più di 1000 FIR per volta in questo blocco',
            }
          ]
        },
  
       
  
      ]
    }
  ]